var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{staticClass:"vue-map",attrs:{"center":_vm.centre,"zoom":13}},[_c('gmap-polyline',{ref:"map",attrs:{"path":_vm.path,"options":_vm.lineOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }